import MicroModal, { MicroModalConfig } from 'micromodal';

// Run the functions on document ready
// just for testing modal view on styleguide
// document.addEventListener('DOMContentLoaded', () => {
//     MicroModal.init();
// });

interface MicroModalConfigExtended extends MicroModalConfig {
    noBodyClass?: boolean;
}

export const openModal = (id: string, config?: MicroModalConfigExtended) => {
    const { noBodyClass = false, ...rest } = config || {};

    MicroModal.show(id, {
        closeTrigger: 'data-modal-close',
        // awaitCloseAnimation: true,
        disableFocus: true,
        onClose: () => document.body.classList.remove('modal-opened'),
        ...rest
    });

    if (!noBodyClass) {
        document.body.classList.add('modal-opened');
    }

    window.dispatchEvent(new Event('resize'));
};

export const closeModal = (id: string) => {
    MicroModal.close(id);
};
